/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:59
 */

/**
 * Created by WJX on 2017/10/17.
 */
var pathObj = {
  javaPath: '',
  wxAppId: '',
  domainName: '',
  webSocketPath: 'ws://danmu.yxvzb.com',
  wxAccount: ''
};
var protocol = location.protocol === 'https:' ? 'https' : 'http'; // (function (){

var locationUrl = location.href;

if (/doc\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: "".concat(protocol, "://doc.jimijiayuan.cn"),
    wxAppId: 'wx07d0029693e87412',
    domainName: 'doc.jimijiayuan.cn',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'linchuang119',
    env: 'development'
  };
} else if (/www\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: "".concat(protocol, "://www.jimijiayuan.cn"),
    wxAppId: 'wxf1c4eecc87711456',
    domainName: 'www.jimijiayuan.cn',
    webSocketPath: 'ws://101.200.74.18:8383',
    wxAccount: 'frozenhome',
    env: 'development'
  };
} else if (/192\.168\.0/.test(locationUrl)) {
  pathObj = {
    javaPath: "".concat(protocol, "://ysh-wxv2.jimijiayuan.cn"),
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'ysh-wxv2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji_xiaowei',
    env: 'development'
  };
} else if (/pc2\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: "".concat(protocol, "://pc2.jimijiayuan.cn"),
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'pc2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji_xiaowei',
    env: 'development'
  };
} else if (/ysh-wxv2\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: "".concat(protocol, "://ysh-wxv2.jimijiayuan.cn"),
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'ysh-wxv2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji_xiaowei',
    env: 'development'
  };
} // else if(/wx\.yxvzb\.com/.test(locationUrl)) {
//   pathObj = {
//     javaPath: `${protocol}://wx.yxvzb.com`,
//     wxAppId: 'wxf1c4eecc87711456',
//     domainName: 'wx.yxvzb.com',
//     webSocketPath: 'ws://192.168.0.105:8383',
//     wxAccount: 'frozenhome'
//   }
// }
else {
  pathObj = {
    javaPath: "".concat(protocol, "://wx.yxvzb.com"),
    wxAppId: 'wx89dc34dd18c86446',
    domainName: 'wx.yxvzb.com',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'vzb0066',
    env: 'production'
  };
} // })();


export default {
  env: pathObj.env,
  protocol: protocol,
  urlPath: '',
  //页面地址
  // urlRoutePath: `${this.urlPath}/html/newWechat.html#/`, // 页面路径
  javaPath: pathObj.javaPath,
  //接口地址
  wxAppId: pathObj.wxAppId,
  //微信APPID
  domainName: pathObj.domainName,
  //域名
  webSocketPath: pathObj.webSocketPath,
  //弹幕
  wxAccount: pathObj.wxAccount,
  //注册来源
  wxAuth: function wxAuth(uri, to) {
    // 授权转跳使用中转页面
    var r = encodeURIComponent("http://cdn.yxvzb.com/WEB/transfer/index.html?vue_redirect_url=".concat(uri));

    if (to.name == 'home' || to.name == 'register') {
      r = encodeURIComponent("http://cdn.yxvzb.com/WEB/transfer/index.html?vue_redirect_url=".concat(location.protocol, "//").concat(location.host, "/html/newWechat.html#").concat(to.fullPath));
    }

    return "https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(this.wxAppId, "&redirect_uri=http%3a%2f%2f").concat(this.domainName, "%2frest%2fysh%2fwx%2fwxIndex%2fauthorizeCallback%3fredirectUri%3d").concat(r, "&response_type=code&scope=snsapi_userinfo&source_type=wx&state=3#wechat_redirect");
  }
};